import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../utils/ApiManager';

/**
 * Custom hook to synchronize the user's selected language with their profile in the backend
 * This only applies to authenticated users
 */
const useLanguageSync = () => {
  const { i18n } = useTranslation();
  
  useEffect(() => {
    // Function to update the user's language preference in the backend
    const updateUserLanguagePreference = async (language) => {
      try {
        // Only make API call if user is authenticated (token exists)
        const token = localStorage.getItem('token');
        if (token) {
          // Use the dedicated language update endpoint
          await api.put('/api/auth/language', {
            defaultLanguage: language
          });
          console.log('Language preference updated successfully');
        }
      } catch (error) {
        console.error('Failed to update language preference:', error);
      }
    };

    // Create language change listener
    const handleLanguageChanged = (lng) => {
      updateUserLanguagePreference(lng);
    };

    // Register language change event listener
    i18n.on('languageChanged', handleLanguageChanged);

    // Cleanup: remove the listener when component unmounts
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n]);

  return null; // This hook doesn't return anything
};

export default useLanguageSync;